export default __webpack_public_path__ + "static/media/save_later_outline.336a640a.svg";